import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { StrategicPillars } from '../components/StrategicPillars';
export function ExecutiveProfile() {
  return <>
      <PageHeader eyebrow="Executive Summary" title="Credentials built at enterprise scale, under national scrutiny." intro="Four strategic pillars define the scope of authority held across the Pentagon, Capitol Hill, statewide agencies and the boardroom." data-id="element-302" data-mp="1q9ydnta7uz26" />
      <StrategicPillars data-id="element-303" data-mp="206bc14gpi139" />
    </>;
}